import React, { memo, useContext } from 'react'

import { Button } from '../index'
import { LanguageContext } from '../../../context/LanguageContext'

const FilterActions = ({ closeSideMenuHandler, filterApplyHandler, isEnable }) => {
    //RtL
    const { rtl, strings } = useContext(LanguageContext)

    //Render
    return (
        <div className={`filter_actions`}>
            <Button
                className={rtl ? 'mr-9' : 'ml-9'}
                color={'light'}
                size={'lg'}
                onClick={closeSideMenuHandler}
            >
                {strings.CANCEL}
            </Button>
            <Button
                className={rtl ? 'mr-9' : 'ml-9'}
                color={'primary'}
                size={'lg'}
                disabled={!isEnable}
                onClick={filterApplyHandler}
            >
                {strings.APPLY}
            </Button>
        </div>
    )
}

export default memo(FilterActions)
